import React from 'react';
import { motion } from 'framer-motion';

//! ----------------------------> PAGE TRANSITION
//* Used by every route in App.js (AnimatePresence mode="wait"):
//*  - leaving: content dims and lifts while a curtain wipes up from the bottom
//*  - entering: the curtain continues upward and the new content settles in
//* Total round-trip ≈ 0.85s, both halves on GPU-friendly transform/opacity.
const CURTAIN_IN = [0.76, 0, 0.24, 1];   // expo-like in/out for the wipe covering the page
const CURTAIN_OUT = [0.22, 1, 0.36, 1];  // fast start, soft landing for the reveal
const CONTENT_EASE = [0.22, 1, 0.36, 1];

const contentVariants = {
    initial: { opacity: 0, y: 24 },
    animate: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, ease: CONTENT_EASE, delay: 0.12 },
    },
    exit: {
        opacity: 0.35,
        y: -16,
        transition: { duration: 0.35, ease: [0.4, 0, 1, 1] },
    },
};

const PageTransition = ({ children }) => (
    <>
        <motion.div
            className="page-content"
            variants={contentVariants}
            initial="initial"
            animate="animate"
            exit="exit"
        >
            {children}
        </motion.div>

        {/* covers the page on exit */}
        <motion.div
            className="page-curtain"
            initial={{ y: '100%' }}
            animate={{ y: '100%' }}
            exit={{ y: '0%', transition: { duration: 0.4, ease: CURTAIN_IN } }}
        />

        {/* reveals the page on enter */}
        <motion.div
            className="page-curtain"
            initial={{ y: '0%' }}
            animate={{ y: '-100%', transition: { duration: 0.5, ease: CURTAIN_OUT } }}
            exit={{ y: '-100%' }}
        />
    </>
);

export default PageTransition;
